import React from 'react';
import PrintIcon from "@material-ui/icons/Print";
import ReactToPrint from 'react-to-print';
import { Button } from '@material-ui/core';

export const BotaoImprimirFormulario = ({ printRef }) => {
    return (
        <ReactToPrint
            trigger={() => (
                <Button
                    size="large"
                    variant="text"
                    disableElevation
                    color="default"
                    endIcon={<PrintIcon />}
                >
                    IMPRIMIR FORMULÁRIO DO PEDIDO
                </Button>
            )}
            content={() => printRef}
        />
    )
}
